/**
 * Auth endpoint wrappers (the cookie-bearing surface).
 *
 * `refresh` is the linchpin: it's called on boot (§2.7.1) and on every 401
 * silent retry (§2.7.7). `logout` is fired by the UserMenu (§2.7.9).
 */
import { request, unwrap } from './client';
import type { ApiResponse, AuthTokenResponse, OperatorMeResponse } from './types';

export const authApi = {
  refresh(): Promise<AuthTokenResponse> {
    return request<AuthTokenResponse>('POST', '/api/auth/refresh', { json: {} });
  },

  logout(): Promise<void> {
    return request<void>('POST', '/api/auth/logout', { json: {} });
  },

  // Authoritative operator identity (SASADM-0081 U3). `_noAuthRetry` keeps a
  // `401` from triggering the silent refresh / signOut path — the caller
  // (`refineOperator`) fails soft.
  async me(): Promise<OperatorMeResponse> {
    const res = await request<ApiResponse<OperatorMeResponse>>('GET', '/api/auth/me', {
      _noAuthRetry: true,
    });
    return unwrap(res);
  },
};
